import { useState } from "react";

import { useTranslation } from "react-i18next";

import "./styles.css";

export default function LanguageToggle() {
  const { i18n } = useTranslation(); // Obtém a instância do i18n
  const langs = ["en", "pt"];

  const [currentLangIndex, setCurrentLangIndex] = useState(
    langs.indexOf(i18n.language) !== -1 ? langs.indexOf(i18n.language) : 1,
  );

  const changeLanguage = (newIndex) => {
    setCurrentLangIndex(newIndex);
    i18n.changeLanguage(langs[newIndex]);
  };

  return (
    <div className="switches-container">
      <input
        type="radio"
        id="switchEnglish"
        name="switchLanguage"
        value="English"
        checked={currentLangIndex === 0}
        onChange={() => changeLanguage(0)}
      />
      <input
        type="radio"
        id="switchPortuguese"
        name="switchLanguage"
        value="Portuguese"
        checked={currentLangIndex === 1}
        onChange={() => changeLanguage(1)}
      />
      <label htmlFor="switchEnglish">English</label>
      <label htmlFor="switchPortuguese">Português</label>
      <div className="switch-wrapper">
        <div className="switch">
          <div>English</div>
          <div>Português</div>
        </div>
      </div>
    </div>
  );
}
